//AzeemKhan : 17-05-2023 : BT-107430 -  Breeze – Watchlist Side Tray - Don't Miss - Start

import { forwardRef, memo, useEffect, useState, useCallback, useMemo } from 'react';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import { Container, Row, Col } from 'react-bootstrap';
import { BzChip, BzInputText, BzToolTip } from '../../../components';
import { useSelector, useDispatch } from 'react-redux';
import { SIDE_TRAY_EXPAND_PERCENTAGE, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';

import uniqBy from 'lodash/uniqBy';
import DontMiss from '../../DontMiss';
import { searchDontMissBySymbol, setDontMissSearchByDropdown } from '../../../redux/actions/dontMiss';
import { deepClone, getDecryptLocalStorage, setEncryptLocalStorage } from '../../../utils/global_functions';
import { handleModal } from '../../../redux/actions/modals';


const FilterDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

const SideDontmiss = ({ setIsExpanded, setToggleSideContainer, setActiveMenu, sideContentId, ...props }) => {//BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23
    const dispatch = useDispatch();

    const dontMissData = useSelector(state => state.dontMiss.dontMissData);
    const arrSearchDontMissByDropdown = useSelector(state => state?.dontMiss?.arrSearchDontMissByDropdown);
    const [dontMissEvent, setDontMissEvent] = useState([]);
    const [arrDontMissEvents, setArrDontMissEvents] = useState([]);
    const [bToggleSearchBar, setBToggleSearchBar] = useState(true);
    const nDontMissCount = useMemo(() => dontMissData?.length - getDecryptLocalStorage('SEEN_DONT_MISS'), []);

    useEffect(() => {
        if (dontMissData?.length > 0) {
            setArrDontMissEvents(uniqBy((dontMissData?.map(each => each[WATCHLIST_GRID_INDEX.DONT_MISS]).flat()), "event"));
            setEncryptLocalStorage('SEEN_DONT_MISS', dontMissData?.length);
        }
    }, [dontMissData]);

    const handleToggleSearchBar = () => {
        setBToggleSearchBar(!bToggleSearchBar);
        dispatch(searchDontMissBySymbol(''));
    };
    // const handleEventFilterChange = useCallback((e) => {
    //     if (dontMissEvent.includes(e.target.value)) {
    //         setDontMissEvent(dontMissEvent?.filter((i) => i !== e.target.value));
    //     } else {
    //         setDontMissEvent([...dontMissEvent, e.target.value]);
    //     }
    // }, [dontMissEvent]);

    const handleSearchScripBySymbol = useCallback((e) => {
        dispatch(searchDontMissBySymbol(e.target.value));
    }, [dispatch]);

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleFilterEventDelete = useCallback((event) => {
        if (dontMissEvent.includes(event)) {
            setDontMissEvent(dontMissEvent?.filter((item) => item !== event));
            dispatch(setDontMissSearchByDropdown(dontMissEvent?.filter((item) => item !== event)));
        } else {
            let copy = deepClone(arrSearchDontMissByDropdown);
            let arrFilteredEvents = copy?.filter((item) => item !== event);
            dispatch(setDontMissSearchByDropdown([...arrFilteredEvents]));
        }
    }, [dontMissEvent, arrSearchDontMissByDropdown, dispatch]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End
    // const handlDropDownToggle = useCallback(() => {
    //     dispatch(setDontMissSearchByDropdown(dontMissEvent));
    // }, [dontMissEvent]);

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleFilterOfDontMiss = useCallback((event) => {
        let copy = deepClone(arrSearchDontMissByDropdown);
        dispatch(setDontMissSearchByDropdown([...copy]));
        dispatch(handleModal([{ "PORTFOLIO_DONT_MISS_FILTERS": true }]));
    }, [dispatch, arrSearchDontMissByDropdown]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End

    return (
        <>
            <ContainerHeader setToggleSideContainer={setToggleSideContainer} sideContentId={sideContentId}>
                <Container fluid className='p-0'>
                    <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text text-uppercase line-height-1'>DON'T MISS</div>
                            {nDontMissCount > 0 && <div className='number-badge float-start ms-2'>{nDontMissCount}</div>}
                            {props.children}
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                    setToggleSideContainer(false);
                                    setActiveMenu({}); 
                                    }}>                                    
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>
                    <Row className='g-0 px-3 py-1 my-2 align-items-center justify-content-end h_40'>
                        <Col md={3} className='d-flex justify-content-start align-items-center'>
                            <BzToolTip placement='right' TooltipMsg='Get scrip related Events, Recommendations and Holding info upfront'>
                                <div className='icon-16 icon-info icon-dark'></div>
                            </BzToolTip>
                        </Col>
                        <Col md={9} className='d-flex justify-content-end align-items-center'>
                            {bToggleSearchBar ?
                                <div className='icon-16 icon-search icon-dark' onClick={handleToggleSearchBar}></div> :
                                <>
                                   <div className='position-relative w-70'>
                                        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                        <BzInputText onChange={handleSearchScripBySymbol.bind(this)} size='sm' type='search' placeholder="search here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                    </div>
                                   <div className='icon-16 icon-dark icon-close ms-2' onClick={handleToggleSearchBar} />
                                 </>
                            }
                            <div className='icon-16 icon-searchfilter icon-dark ms-3' onClick={(e) => handleFilterOfDontMiss(e)}></div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className='p-0'>
                    {arrSearchDontMissByDropdown?.length > 0 &&
                        <Row className='g-0 mx-2 mb-2'>
                            <Col className='d-flex align-items-center'>                                
                                <div className='font-medium font-size3 color-text me-2'>Filters:</div>
                                <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap py-1'>
                                    {arrSearchDontMissByDropdown?.map((event) =>
                                        <BzChip className='filter-chip me-1 text-capitalize'>{event}<div className='icon-10 icon-close icon-dark ms-2' onClick={handleFilterEventDelete.bind(this, event)}></div></BzChip>
                                    )}
                                </div>                                
                            </Col>
                        </Row>
                    }
                </Container>
            </ContainerHeader>

            <ContainerBody>
                <DontMiss setDontMissEvent={setDontMissEvent} handleFilterEventDelete={handleFilterEventDelete} />
            </ContainerBody>

        </>
    );
};

export default memo(SideDontmiss);
//AzeemKhan : 17-05-2023 : BT-107430 -  Breeze – Watchlist Side Tray - Don't Miss - End